(function () {
  if (window.__obCfgInit) return;
  window.__obCfgInit = true;

  function submits(form) {
    return Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
  }

  function setLocked(picker, form, locked) {
    picker.dataset.obLocked = locked ? '1' : '';
    var err = picker.querySelector('[data-ob-error]');
    if (err) err.hidden = !locked || picker.dataset.obTouched !== '1';
    if (!locked) {
      submits(form).forEach(function (btn) {
        if (btn.dataset.obLock === '1') {
          btn.disabled = false;
          btn.dataset.obLock = '';
        }
      });
    }
  }

  function setup(picker) {
    if (picker.dataset.obReady) return;
    picker.dataset.obReady = '1';
    var required = picker.dataset.required !== 'false';
    var form = document.getElementById(picker.dataset.formId);
    if (!form) return;
    var hidden = picker.querySelector('[data-ob-property]');
    var radios = picker.querySelectorAll('input[type="radio"]');

    if (required) {
      submits(form).forEach(function (btn) {
        if (!btn.disabled) {
          btn.disabled = true;
          btn.dataset.obLock = '1';
        }
      });
      picker.dataset.obLocked = '1';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (hidden) hidden.value = radio.value;
        picker
          .querySelectorAll('[data-ob-option]')
          .forEach(function (opt) { opt.classList.remove('is-selected'); });
        var label = radio.closest('[data-ob-option]');
        if (label) label.classList.add('is-selected');
        picker.dataset.obTouched = '1';
        if (required) setLocked(picker, form, false);
      });
    });

    form.addEventListener('submit', function (e) {
      if (required && (!hidden || !hidden.value)) {
        e.preventDefault();
        picker.dataset.obTouched = '1';
        setLocked(picker, form, true);
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-ob-picker]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
